import apiOutstanding from '@/api/supplier/poOutstanding';
import apiOption from '@/api/supplier/option';

const defaultState = () => ({
	outstandingResults: [],
	detailOutstanding: '',
	outstandingPagination: '',
	optionWarehouse: [],
	responSukses: '',
	alert: '',
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {
	listoutstanding(state, data) {
		state.outstandingResults = data.data;
		state.outstandingPagination = data.pagination;
	},
	setDetailOutstanding(state, data) {
		state.detailOutstanding = data
	},
	listOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataoutstanding(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getOutStanding({ commit }, value) {
		return new Promise((resolve) => {
			apiOutstanding.getOutStanding(value).then(({ data: { data } }) => {
				commit('listoutstanding', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('listoutstanding', { data: [], pagination: {} });
			});
		});
	},
	getDetailOutstanding({ commit, dispatch }, params) {
		apiOutstanding.detailOutstanding(params).then(({ data: { data } }) => {
			commit('setDetailOutstanding', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailOutstanding', { data: [] });
		});
	},
	getOptionWarehouse({ commit }, value) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(value).then(({ data: { data } }) => {
				commit('listOptionWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('listOptionWarehouse', []);
			});
		});
	},
	async exportOutStanging({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiOutstanding.exportOutStanging(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data outstanding'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};